import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class LightboxService {
  private _openPreviewAtIndex = new Subject<number>();
  public openPreviewAtIndex = this._openPreviewAtIndex.asObservable();

  private _previewOpened = new Subject<boolean>();
  public previewOpened = this._previewOpened.asObservable().pipe(distinctUntilChanged());

  closePreview() {
    this._previewOpened.next(false);
  }

  openFullScreen(index: number) {
    this._previewOpened.next(true);
    this._openPreviewAtIndex.next(index);
  }
}
